module.exports = "/images/thomas.jpg?fa00ded7eb9c12781a5ca46f879478bc";